export default "__VITE_ASSET__D5L_WVo0__"